import Vue from "vue";
import * as Sentry from "@sentry/vue";
import router from "@/router";

export function sentryInit() {
  if (process.env.VUE_APP_ENV === "localhost") return;
  Sentry.init({
    Vue,
    dsn: "https://3b89895937ad99e78f3d2d04ac92678a@o4508650764173312.ingest.us.sentry.io/4509049067339776",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],

    normalizeDepth: 4,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [
      "localhost",
      /https:\/\/.*\.haii\.io/,
      /https:\/\/.*\.co.kr/
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.VUE_APP_ENV
  });
}

